<template>
  <div class="d-flex flex-wrap media-list media-attachment" v-if="hasItems">
    <div class="media-list__item media-attachment__thumbnails border border-gray-200" v-for="item in this.value">
      <component v-on:click.native="preview(item)" v-bind:is="getMediaComponent(item)" :key="item.id" :item="item"></component>
      <div class="media-list__item-remove" @click="remove(item)">
        <i class="fas fa-times-circle"></i>
      </div>
    </div>
  </div>
</template>

<script>
import ImageComponent from "./types/image";
import VideoComponent from "./types/video";
import PdfComponent from "./types/pdf";

export default {
  components: {
    'image-component': ImageComponent,
    'video-component': VideoComponent,
    'pdf-component': PdfComponent,
  },

  props: {
    value: Array,
  },

  computed: {
    /**
     * @return {boolean}
     */
    hasItems() {
      return _.isArray && ! _.isEmpty(this.value);
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    remove({id}) {
      this.emit(
        _.reject(this.value, {id})
      );
    },

    /**
     * @param {Object} items
     */
    addItems(items) {
      this.emit(items);
    },

    /**
     * @return {undefined}
     */
    clear() {
      this.emit([]);
    },

    /**
     * @param item
     * @event show-media-show-dialog
     */
    preview(item) {
      eventBus.$emit('show-media-show-dialog', {
        mimeType: _.get(item, 'mime_type'),
        url: _.get(item, 'full_url'),
      });
    },

    /**
     * @return {String}
     */
    getMediaComponent(item) {
      let mime =  _.get(item, 'mime_type');
      if (RegExp('^video\/', 'i').test(mime)) {
        return 'video-component';
      }

      if (RegExp('^application\/pdf', 'i').test(mime)) {
        return 'pdf-component';
      }

      return 'image-component';
    },

    /**
     * @param value
     * @emits 'input
     */
    emit(value) {
      this.$emit('input', value);
    }
  },

  created() {
    eventBus.$on('add-media-items-to-message', this.addItems);
  },

  beforeDestroy() {
    eventBus.$off('add-media-items-to-message', this.addItems);
  },
}
</script>
